import { useState } from 'react';

export type BindSelect = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
};

export const useSelect = (
  initialValue: string,
  field: string,
  onChangeHook?: (field: string, value: string) => void,
  onBlurHook?: (field: string, value: string) => void,
) => {
  const [value, setValue] = useState<string>(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (val: string) => {
        setValue(val);
        if (onChangeHook) {
          onChangeHook(field, val);
        }
      },
      ...(onBlurHook ? { onBlur: () => onBlurHook(field, value) } : {}),
    },
  };
};
